// src/components/ResponsiveDatagrid.js
import React from 'react';
import { Datagrid, SimpleList } from 'react-admin';
import { useMediaQuery } from '@mui/material';

const ResponsiveDatagrid = (props) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    if (isSmall) {
        // Use a simple list on small screens
        // You can customize primaryText, secondaryText etc. based on the resource
        return <SimpleList primaryText={record => record.name || record.origin} {...props} />;
    }
    // Use the full datagrid on larger screens
    return <Datagrid {...props} />;
};

export default ResponsiveDatagrid;